import React, { useState } from 'react';
import './Policy.css';
import Footer from '../../components/Footer/Footer';
import NavBar from '../../components/NavBar/NavBar';
import { useNavigate } from 'react-router-dom';

const Policy = () => {
    const navigation = useNavigate()
      const [loading, setLoading] = useState(false); // Loader state
    

  return (
    <>
    <NavBar />
    <div className="policy-container">
      {/* Website Banner */}
      <div className="website-banner">
        <h1 className="website-title">Welcome to Our Website</h1>
        <p className="website-subtitle">
          Explore our policies and understand how we protect your data and ensure a seamless experience.
        </p>
      </div>

      <h2 className="policy-header">Our Policies</h2>

      <div className="policy-content">
        {/* Privacy Policy Section */}
        <div className="policy-section">
          <h2 className="policy-section-title">Privacy Policy</h2>
          <p className="policy-text">
            Your privacy is our top priority. We are committed to protecting your personal information and adhering to
            data protection laws. Here's how:
          </p>
          <ul className="policy-list">
            <li>We do not sell or share your data without consent.</li>
            <li>All data is encrypted and stored securely.</li>
            <li>Cookies are used solely to enhance your browsing experience.</li>
          </ul>
          <p className="policy-highlight">For full details, read our complete Privacy Policy document.</p>
        </div>

        {/* Terms and Conditions Section */}
        <div className="policy-section">
          <h2 className="policy-section-title">Terms and Conditions</h2>
          <p className="policy-text">
            By using our services, you agree to comply with our terms and conditions. We strive to maintain transparency
            and ensure that our platform remains safe for all users.
          </p>
          <ul className="policy-list">
            <li>Content on our website is copyrighted and cannot be reused.</li>
            <li>You must not engage in any activity that disrupts our services.</li>
            <li>We reserve the right to suspend accounts violating these terms.</li>
          </ul>
          <p className="policy-highlight">Make sure to review the full Terms and Conditions for complete information.</p>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="cta-section">
        <h2 className="cta-title">Have Questions?</h2>
        <p className="cta-text">
          If you have any concerns about our policies or need further clarification, feel free to contact our support
          team.
        </p>
        <button className="cta-button" onClick={() => navigation("/contact-us")}>Contact Support</button>

      </div>
    </div>
    <Footer />
    </>
  );
};

export default Policy;
